import { createRequest, RequestConfig } from '../../../core/libs/api';

const config: RequestConfig = {
  method: 'get',
  url: '/ws/api/unauth/get_trip_details',
};

export const getTripDetailsRequest = (id: string) =>
  createRequest({
    query: { id },
    url: config.url,
    method: config.method,
  });
